import React, { useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Select, Button, Modal, message, Tooltip, Icon } from 'antd';
import { Grid } from '@material-ui/core';
import TextEvents from '../TextEvents';
import TextInput from 'app/components/TextInput';
import { styles, useStyles } from './PEPRepresentativeFormStyles';
import PEPRepresentativeTableContainer from 'app/containers/PEPRepresentativeTableContainer';
import { fetchPEPRepresentative, pepRepresentativeClear, fetchPEPRepresentativeFilter, pepRepresentativeClearFilter } from 'app/actions/PEPRepresentativeActions';
import ApiService from 'app/services/ApiService';

const { confirm } = Modal;
const { Option } = Select;
const SelectItem = (name = [], value) => {
    let x = name[value]
    return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={i}>{c}</Option>) : (x === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);

}

export default function PEPRepresentativeForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [name, setName] = useState([]);
    const [collapse, setCollapse] = useState(true);

    const data = {
        responsibleName: props.FiltroNombre.join('|'),
        idRol: 4,
        sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
        sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === "ascend" ? "ASC" : "DESC" : '',
        offset: (0 * props.pagination.pageSize),
        limit: props.pagination.pageSize
    }

    const {
        siteId
    } = useSelector(state => state.Auth);

    const submit = () => {
        ApiService.setResponsible({ idResponsible: props.idResponsible, responsibleName: props.nameResponsible, idRol: 4 }, props.idResponsible > 0 ? 'PUT' : 'POST').then(
            res => {
                props.isVisibleForm(false)
                message.success(`El Representante PEP ${props.nameResponsible} se guardó correctamente!`);
                dispatch(pepRepresentativeClearFilter());
                dispatch(fetchPEPRepresentativeFilter({ idRol: 4 }));
                search();
                props.setNameResponsible('');
            },
            error => {
                message.error('Ocurrió un error intente mas tarde.');
            }
        );
    }
    const search = () => {
        dispatch(pepRepresentativeClear());
        dispatch(fetchPEPRepresentative(data));
        props.setFormData(data);
    }

    const newSpecialty = () => {
        props.setIdResponsible(0);
        props.setNameResponsible('');
        props.isVisibleForm(true);
    }

    const toExport = async () => {
        await ApiService.getResponsibleExport(4, data)
            .then(
                result => {
                    const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    downloadFile(blob, "BandejaRepresentantesPEP.xlsx");
                },
                error => {
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }

    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    };

    const handleChange = (value, i, key) => {
        const array = [];
        i.map(i => {
            array.push(i.props.children);
            return array;
        })
        if (i.length === 0) {
            switch (key) {
                case 'reponsibleName':
                    setName([])
                    props.setFiltroNombre([]);
                    break;
                default:
                    break;
            }
        }
        // eslint-disable-next-line array-callback-return
        i.map(() => {
            if (key === 'reponsibleName') {
                setName([array])
                props.setFiltroNombre(array);
            }
        })
    }

    return (
        <div>
            <PEPRepresentativeTableContainer>
                {(params) => {
                    return (
                        <div>
                            <div hidden={collapse}>
                                <Grid container direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Nombre:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            value={props.FiltroNombre}
                                            optionFilterProp="children"
                                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                            placeholder="Selecciona nombre"
                                            onChange={(v, i) => handleChange(v, i, 'reponsibleName')}
                                        >
                                            {SelectItem(params.sspaRepresentativeFilter[0], 'name')}
                                        </Select>
                                    </Grid>
                                </Grid>
                            </div>
                            <div className={classes.container} style={styles.baseVerticalMargin}>
                                 {
                                    collapse ?
                                        <Tooltip title={"Mostrar filtro"}>
                                        <Button
                                            className={classes.button}
                                            variant="contained"
                                            type="link"
                                            onClick={() => setCollapse(false)}
                                        >
                                            <Icon type="down" />
                                        </Button>
                                        </Tooltip> :
                                        <Tooltip title={"Ocultar filtro"}>
                                        <Button
                                            className={classes.button}
                                            variant="contained"
                                            type="link"
                                            onClick={() => setCollapse(true)}
                                        >
                                            <Icon type="up" />
                                        </Button>
                                        </Tooltip>
                                }
                                
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    onClick={() => search()}
                                >
                                    Buscar
                                </Button>
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    onClick={toExport}
                                >
                                    Exportar
                                </Button>
                                {siteId === 'HUB' ?
                                    <Button
                                        className={classes.button}
                                        variant="contained"
                                        type="primary"
                                        onClick={newSpecialty}
                                    >
                                        Nuevo
                                    </Button> : null
                                }
                            </div>
                        </div>
                    )
                }}
            </PEPRepresentativeTableContainer>
            <Modal
                destroyOnClose={true}
                onCancel={() => props.isVisibleForm(false)}
                visible={props.visibleForm}
                title={<TextEvents
                    text={props.idResponsible > 0 ? 'Editar Representante PEP' : 'Nuevo Representante PEP'}
                    color='cotemar'
                    size='label'
                    weight='bold'
                />}
                width={'650px'}
                centered={true}
                footer={[
                    <Button key="back" type="danger" ghost onClick={() => props.isVisibleForm(false)}>
                        Cancelar
                    </Button>,
                    siteId === 'HUB' ?
                        <Button disabled={props.nameResponsible === ''} key="submit" type="primary" loading={false} onClick={() => submit()}>
                            Confirmar
                        </Button> : null,
                ]}
            >
                <Grid container direction="row">
                    <Grid item xs={12}>
                        <TextInput
                            disabled={siteId !== 'HUB'}
                            value={props.nameResponsible}
                            setValue={props.setNameResponsible}
                            text='Nombre del Representante PEP:'
                            color='darker'
                            size='label'
                            weight='medium'
                            mode='input'
                            placeholder='Nombre'
                        />
                    </Grid>
                </Grid>
            </Modal>
        </div>
    );
}